import { DEFAULT_CALENDAR_STRINGS } from '../../utils';
import type { CalendarStrings } from '../../utils';

export const defaultCalendarStrings: CalendarStrings = DEFAULT_CALENDAR_STRINGS;
